// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__ou8rm","name":"ConsentHeader_name__2DtNs","birthday":"ConsentHeader_birthday__bMnX0","skeleton":"ConsentHeader_skeleton__A9cW0"};